import { Detect } from "../internal/Detect"

/** `IntersectionObserver`, or `undefined` where the environment has none (absent in workers and node). */
export const GetIntersectionObserver = (): typeof IntersectionObserver | undefined =>
  Detect("IntersectionObserver")
